<ng-template #modal let-modal>
  <div class="offcanvas-header border-bottom">
    <h4 class="modal-title mt-0">{{ "heading-title.filter" | translate }}</h4>
    <button type="button" class="btn-close" (click)="closeModal()" id="close-filter-data-modal"></button>
  </div>
  <div class="offcanvas-body">
    <div class="row">
      @for(collepsibleFilter of collepsibleFilters; track $index) {
      <app-collapsible-filter
        title="{{ collepsibleFilter.title | translate }}"
        placeholder="{{ collepsibleFilter.placeholder | translate }}"
        [isDropdown]="collepsibleFilter.isDropdown"
        [isDatePicker]="collepsibleFilter.isDatePicker"
        [isInput]="collepsibleFilter.isInput"
        [isMultiple]="collepsibleFilter.isMultiple"
        [selectedValue]="collepsibleFilter.selectedValue"
        [selectedOperator]="collepsibleFilter.selectedOperator"
        [isMultiLanguageValue]="collepsibleFilter.isMultiLanguageValue"
        [data]="collepsibleFilter.data"
        [conditionOperators]="collepsibleFilter.conditionOperators"
        [filterKey]="collepsibleFilter.filterKey"
        [conditionOperatorKey]="collepsibleFilter.conditionOperatorKey"
        [metaData]="collepsibleFilter.metaData"
        [isOpen]="openSection === collepsibleFilter.filterKey"
        (dataSelect)="onCollapsibleFilterChange($event)"
        (sectionToggled)="toggleSection(collepsibleFilter.filterKey)"
      ></app-collapsible-filter>
      }
    </div>
  </div>
  <div class="offcanvas-footer text-end border-top">
    <button type="button" class="btn btn-outline-secondary me-2" id="clear-filter-modal" (click)="clearFilter(true)">{{ "button-title.clear" | translate }}</button>
    <button type="button" class="btn btn-secondary" (click)="applyFilter()" id="apply-filter-modal">{{ "button-title.apply" | translate }}</button>
  </div>
</ng-template>
